module.exports = __webpack_public_path__ + "img/bg_0.307e9d2f.png";